import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { toast } from "react-toastify";

const apiClient = new APIClient();

const ModalCampanha = ({ isOpen, toggle, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: "",
    descricao: "",
    validade: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Validação do tamanho da descrição
    if (name === "descricao" && value.length > 600) {
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.nome.trim()) {
      errors.push("Nome da campanha é obrigatório");
    }

    if (!formData.validade) {
      errors.push("Data de validade é obrigatória");
    } else {
      const validadeDate = new Date(formData.validade);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (validadeDate <= today) {
        errors.push("A data de validade deve ser futura");
      }
    }

    if (formData.descricao && formData.descricao.length > 600) {
      errors.push("A descrição não pode ter mais de 600 caracteres");
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    if (errors.length > 0) {
      errors.forEach(error => toast.error(error));
      return;
    }

    setLoading(true);
    try {
      const response = await apiClient.post("/campanhas-voucher", formData);
      if (response?.dados) {
        toast.success("Campanha criada com sucesso!");
        onSuccess();
        toggle();
        setFormData({ nome: "", descricao: "", validade: "" });
      } else {
        toast.error(response?.mensagem || "Erro ao criar campanha");
      }
    } catch (error) {
      toast.error("Erro ao criar campanha");
    }
    setLoading(false);
  };

  // Calcula a data mínima (hoje) para o campo de validade
  const today = new Date().toISOString().split("T")[0];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          <span className="fw-semibold">Nova Campanha</span>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="nome" className="fw-medium">
              Nome da Campanha <span className="text-danger">*</span>
            </Label>
            <Input
              id="nome"
              name="nome"
              type="text"
              placeholder="Ex: Black Friday 2024"
              value={formData.nome}
              onChange={handleChange}
              required
              maxLength={255}
            />
          </FormGroup>
          
          <FormGroup className="mt-3">
            <Label for="descricao" className="fw-medium">
              Descrição
              <small className="text-muted ms-2">
                ({formData.descricao.length}/600 caracteres)
              </small>
            </Label>
            <Input
              id="descricao"
              name="descricao"
              type="textarea"
              rows="3"
              placeholder="Descreva o objetivo da campanha"
              value={formData.descricao}
              onChange={handleChange}
              maxLength={600}
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="validade" className="fw-medium">
              Data de Validade <span className="text-danger">*</span>
            </Label>
            <Input
              id="validade"
              name="validade"
              type="date"
              min={today}
              value={formData.validade}
              onChange={handleChange}
              required
            />
            <small className="text-muted">
              A campanha ficará ativa até esta data
            </small>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="light"
            onClick={toggle}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            color="info"
            className="ms-2"
            disabled={loading}
          >
            {loading ? (
              <Spinner size="sm" className="me-2" />
            ) : null}
            Criar Campanha
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ModalCampanha; 